import React, { useEffect, useState } from "react";
import PT from "prop-types";
import { useSelector } from "react-redux";
import get from "lodash/get";
import { parseUrl } from "query-string";
import { sendOtp, updateWithOtp, register } from "@quintype/bridgekeeper-js";

import EditIcon from "../../atoms/EditIcon";
import EyeClose from "../../atoms/EyeCloseIcon";
import EyeOpen from "../../atoms/EyeOpenIcon";
import { useTimer } from "../../atoms/timer";

import "./forms.m.css";

const OTP = ({ member, setLoading, customCallbackUrl = "/", setActiveTab }) => {
  const qtConfig = useSelector((state) => get(state, ["qt"], {}));
  const currentPath = get(qtConfig, ["currentPath"], "");
  const [otp, setOTP] = useState("");
  const [error, setError] = useState("");
  const [otpVisible, setOtpVisible] = useState(false);

  const { start, time } = useTimer();

  useEffect(() => {
    start(180);
  }, []);

  const trackRegistrationEvent = ({ userId }) => {
    if (typeof window !== "undefined" && window.dataLayer) {
      window.dataLayer.push({
        event: "dl_signup",
        subscription_status: "registered",
        user_id: userId,
        login_status: "logged in",
      });
    }
  };

  const otpHandler = async (e) => {
    e.preventDefault();
    e.stopPropagation();

    setLoading(true);

    try {
      const user = {
        "verification-status": "email",
      };
      const registerUser = await register(member);

            // Handle registration errors (this was the commented else part from register.js)
      if (!registerUser || !registerUser.user) {
        setError("Registration failed. Please try again.");
        if (typeof window !== "undefined" && window.dataLayer) {
          window.dataLayer.push({
            event: "dl_signup_error",
            event_action: "registration_failed",
            event_message: "Registration failed. Please try again.",
          });
        }
        return; // Stop here if registration failed
      }

      // If registration successful, proceed with OTP verification
      const response = await updateWithOtp(otp, user);

      if (response.status === 200) {
        // Track otp submit
        if (typeof window !== "undefined" && window.dataLayer) {
          window.dataLayer.push({
            event: "dl_signup_steps",
            event_action: "otp_entered",
          });
        }
        const params = parseUrl(currentPath);
        const urlParam = get(params, ["query", "url"]);
        const callbackUrl = urlParam !== undefined && urlParam !== null ? urlParam : customCallbackUrl;
        const callbackUrlWithToast = `${callbackUrl}?toastMessage=You have successfully Signed In!`;
        window.location.href = callbackUrlWithToast;
        trackRegistrationEvent({ userId: member?.id });
      } else {
        setError("Error while processing OTP");
        if (typeof window !== "undefined" && window.dataLayer) {
          window.dataLayer.push({
            event: "dl_signup_error",
            event_action: "otp_process_error",
            event_message: "Error while processing OTP",
          });
        }
      }
    } catch (err) {
      console.warn("error", error);
      if (typeof window !== "undefined" && window.dataLayer) {
        window.dataLayer.push({
          event: "dl_signup_error",
          event_action: "wrong_otp",
          event_message: err,
        });
      }
    } finally {
      setLoading(false);
    }
  };

  const setData = (e) => {
    setOTP(e.target.value);
  };

  const resendOTP = async () => {
    const data = {
      email: member.email,
    };
    try {
      start(180);
      const res = await sendOtp(data);
      if (res.status === 200) {
        console.log(`OTP Sent to your registered email`);
      } else {
        console.error(res.error || res);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const formatTime = (time) => {
    const minutes = Math.floor(time / 60);
    const seconds = time % 60;
    return `${minutes < 10 ? `0${minutes}` : minutes}:${seconds < 10 ? `0${seconds}` : seconds}`;
  };

  return (
    <div styleName="auth-container otpContainer">
      <h2 styleName="title">
        Enter the OTP for {member.email}
        <span styleName="email" onClick={() => setActiveTab("landing")}>
          <EditIcon />
        </span>
      </h2>

      <form onSubmit={otpHandler} styleName="form">
        <label htmlFor="otp" styleName="auth-label">
          Enter OTP
        </label>
        <div styleName="otpInputContainer">
          <input
            type={otpVisible ? "text" : "password"}
            id="otp"
            name="Enter OTP"
            value={otp}
            onChange={setData}
            placeholder="Enter OTP"
            onFocus={() => setError("")}
            required
            maxLength={6}
            styleName="auth-input"
          />
          <button type="button" styleName="toggleButton" onClick={() => setOtpVisible(!otpVisible)}>
            {otpVisible ? <EyeClose /> : <EyeOpen />}
          </button>
        </div>

        {time === 0 ? (
          <button type="button" onClick={resendOTP} styleName="resendButton">
            Resend OTP
          </button>
        ) : (
          <p styleName="resendText">
            Resend OTP in <span styleName="timer">{formatTime(time)}</span>
          </p>
        )}

        {error && <p styleName="error">{error}</p>}

        <button type="submit" styleName="submit-button">
          Verify & Sign In
        </button>
      </form>
    </div>
  );
};

OTP.propTypes = {
  member: PT.object,
  customCallbackUrl: PT.string,
  onSignup: PT.func,
  setLoading: PT.func,
  setActiveTab: PT.func,
};

export { OTP };
